import React, { useState, useEffect } from "react";
import { Button, Table } from "reactstrap";
import { deepClone, openLinkInNewTab, showToast } from "../../helper-methods";
import PaginatedItems from "../../components/PaginatedItems";
import { fetchProvider, fetchServices } from "../../http/http-calls";
import ProviderView from "../../components/Modals/ProviderView";
import ProviderNotesModal from "../../components/Modals/ProviderNotesModal";
import AddProviderModal from "../../components/Modals/AddProviderModal";

const ResourceDataBaseDataTable = () => {
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  // provider
  const [provider, SetProvider] = useState(false);
  // Add Provider
  const [Addprovider, SetAddprovider] = useState(false);
  const [notesModal, SetNotesModal] = useState({
    isOpen: false,
    data: null,
  });

  const [editDetails, setEditDetails] = useState(null);
  const [payload, setPayload] = useState({
    pageNumber: 1,
    pageSize: 10,
  });

  const [providers, SetProviders] = useState([]);
  const [viewCountyService, setViewCountyService] = useState(null);
  const [services, setServices] = useState([]);

  const [count, setCount] = useState("");
  const [itemsPerPages, setItemsPerPages] = useState("");

  const _fetchAllProviders = async (newPayload) => {
    try {
      const res = await fetchProvider(newPayload ? newPayload : payload);
      console.log("providers", res);
      SetProviders(res?.provider);
      setCount(res?.providersCount);
      setItemsPerPages(res?.provider?.length);
    } catch (error) {
      console.log("error", error);
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    }
  };

  const _fetchAllServices = async () => {
    try {
      const res = await fetchServices();
      console.log("allservices", res);
      setServices(res?.data);
    } catch (error) {
      console.log("error", error);
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    }
  };

  // provider
  const _ProviderToggle = (isOpen = false) => {
    SetProvider(isOpen);
    setViewCountyService(null);
  };

  const _servicesHandler = (details) => {
    _ProviderToggle(true);
    setViewCountyService(details);
  };

  // Add Provider
  const _AddProviderToggle = (isOpen = false) => {
    SetAddprovider(isOpen);
    setEditDetails(null);
  };

  const _NotesModalToggle = (isOpen = false, data = null) => {
    SetNotesModal({
      isOpen: isOpen,
      data: data,
    });
  };

  const _editHandler = (details) => {
    _AddProviderToggle(true);
    setEditDetails(details);
  };

  const _handlePageClick = (pageNumber) => {
    // console.log(pageNumber);
    let newPageConfig = deepClone(payload);
    newPageConfig["pageNumber"] = pageNumber + 1;
    setPayload(newPageConfig);
    _fetchAllProviders(newPageConfig);
  };

  useEffect(() => {
    _fetchAllProviders();
    _fetchAllServices();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="innerWrapper">
        <div className="PgTitle">
          <h4 className="pg-heading mb-4">View Resource Database</h4>
        </div>
        <Table responsive>
          <thead>
            <tr>
              <th>Company</th>
              <th>Owner</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Web Site</th>
              <th>Resources</th>
              <th>Notes</th>
              <th>Description</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>ZIP Code</th>
              <th>Non-Profit</th>
              <th>Charge for Services</th>
              <th>Application Status</th>

              <th style={{ width: 140, textAlign: "right" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers?.length ? (
              providers?.map((data, index) => (
                <tr key={index}>
                  <td>
                    <div style={{ width: "150px" }}>{data?.providerName} </div>
                  </td>
                  <td>
                    <div style={{ width: "150px" }}>
                      {data?.contactName?.last
                        ? data?.contactName?.first.concat(
                            " ",
                            data?.contactName?.last
                          )
                        : data?.contactName?.first}
                    </div>
                  </td>
                  <td>
                    <div className="tdTextWrap" style={{ width: 150 }}>
                      {data?.providerEmail}
                    </div>
                  </td>
                  <td className="cursorPointer">
                    <div className="link tdTextWrap">{data?.providerPhone}</div>
                  </td>
                  <td className="cursorPointer">
                    <div
                      className="tdTextWrap"
                      onClick={() => openLinkInNewTab(data?.providerWebsiteUrl)}
                    >
                      {data?.providerWebsiteUrl}{" "}
                    </div>
                  </td>
                  <td>
                    {data?._service?.length}
                    <Button
                      color="link"
                      style={{ width: 50 }}
                      onClick={() => _servicesHandler(data)}
                    >
                      <i style={{ fontSize: 17 }} className="fa fa-eye"></i>
                    </Button>
                  </td>
                  <td>
                    <Button
                      color="link"
                      onClick={() => {
                        _NotesModalToggle(true, data);
                      }}
                      style={{ width: 50 }}
                    >
                      <i className="fa fa-file mr-2"></i>
                      <span>{data?._note?.length}</span>
                    </Button>
                  </td>
                  <td>
                    <div className="tdTextWrap">
                      <span>
                        {expandedDescriptions[index]
                          ? data?.description || "--"
                          : (data?.description?.slice(0, 30) || "--") +
                            (data?.description?.length > 30 ? "..." : "")}
                      </span>

                      {data?.description?.length > 30 && (
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a
                          style={{
                            cursor: "pointer",
                            marginLeft: "5px",
                            display: "inline-block",
                          }}
                          onClick={() =>
                            setExpandedDescriptions((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          {expandedDescriptions[index]
                            ? "See Less"
                            : "See More"}
                        </a>
                      )}
                    </div>
                  </td>
                  <td className="provider-address">
                    {data?.providerAddress || data?.address?.addressLne || "--"}
                  </td>
                  <td className="provider-address">{data?.address?.city}</td>
                  <td className="provider-address">{data?.address?.state}</td>
                  <td className="provider-address">{data?.address?.zipcode}</td>

                  <td>{data?.isNonProfit ? "Yes" : "No"}</td>
                  <td>{data?.isChargeable ? "Yes" : "No"}</td>
                  <td>
                    <Button
                      color="link"
                      className={
                        data?.status === "accepted"
                          ? "text-success"
                          : data?.status === "rejected"
                          ? "text-danger"
                          : "text-warning"
                      }
                    >
                      {data?.status?.charAt(0)?.toUpperCase() +
                        data?.status?.slice(1)}
                    </Button>
                  </td>

                  <td>
                    <div className="action">
                      <Button
                        color="link"
                        className="btn-edit"
                        onClick={() => _editHandler(data)}
                      >
                        <i className="fa fa-pencil"></i>
                      </Button>
                      {/* <Button
                          color="link"
                          className="btn-delete"
                          onClick={() => _removeUser(data?._id)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={12}>
                  <div className="noData">
                    <img
                      src={require("../../assets/img/noData.svg").default}
                      alt="no data"
                    />
                    <p>There is no data to display</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <PaginatedItems
          itemsPerPages={itemsPerPages}
          totalCount={count}
          selectedPage={payload.pageNumber}
          itemsPerPage={payload.pageSize}
          onPageChange={_handlePageClick}
        />

        <ProviderView
          viewCountyService={viewCountyService}
          isOpen={provider}
          toggle={() => _ProviderToggle()}
        />

        {/* provider notes */}
        {notesModal?.isOpen && (
          <ProviderNotesModal
            isOpen={notesModal?.isOpen}
            toggle={() => _NotesModalToggle()}
            data={notesModal?.data}
            fetchAllProvider={_fetchAllProviders}
          />
        )}
        {/*Add provider  */}
        {Addprovider && (
          <AddProviderModal
            isOpen={Addprovider}
            toggle={() => _AddProviderToggle()}
            fetchAllProvider={_fetchAllProviders}
            isEdit={editDetails === null ? false : true}
            editDetails={editDetails}
            services={services}
          />
        )}
      </div>
    </>
  );
};

export default ResourceDataBaseDataTable;
